export default function FlightTravellers(
    $compile,
    $templateRequest,
    flightsUtils,
    l10nService
) {
    'ngInject';

    return {
        restrict: 'AE',
        scope: {
            options: '=options',
            params: '=params',
            templateUrl: '@templateUrl',
        },
        link: function(scope, element) {
            scope.l10n = l10nService;

            Object.defineProperty(
                scope, 'totalChildren', {
                    get: function() {
                        const infants = +this.params.Travelers.Infant.value;
                        const children = +this.params.Travelers.Child.value;
                        let result = '';

                        if (children === 1) {
                            result += l10nService.localize('1 child ');
                        } else if (children > 1) {
                            result += children + l10nService.localize(' children ');
                        }

                        if (children && infants) {
                            result += ' + ';
                        }

                        if (infants === 1) {
                            result += l10nService.localize('1 infant');
                        } else if (infants > 1) {
                            result += infants + l10nService.localize(' infants');
                        }

                        if ((children + infants) === 0) {
                            result += '0 ' + l10nService.localize('children');
                        }
                        return result;
                    },
                    set: function() {
                    },
                }
            );

            scope.onAdultsChange = function(value) {
                const adults = +value;
                const params = scope.params;
                const infants = +params.Travelers.Infant.value;
                const children = +params.Travelers.Child.value;

                scope.options.infants = flightsUtils.makeTravellersOptions(l10nService.localize('Infant'), adults, true);
                scope.options.children = flightsUtils.makeTravellersOptions(l10nService.localize('Child'), 4 - adults, true);

                if ((children + adults) > 4 || adults < infants) {
                    params.Travelers.Infant = angular.copy(scope.options.infants[0]);
                    params.Travelers.Child = angular.copy(scope.options.children[0]);
                }
            };

            $templateRequest(scope.templateUrl).then(function(html) {
              element.html(html).show();
              $compile(element.contents())(scope);
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/directives/train-traveller-directive.js